import {
  trackClientError,
  trackUnhandledRejection,
  truncateMessage,
} from "@/lib/telemetry/bpm-telemetry";

declare global {
  interface Window {
    __bpmGlobalTelemetryInstalled?: boolean;
  }
}

const RESIZE_OBSERVER_LOOP_ERROR_PATTERN =
  /^ResizeObserver loop (completed with undelivered notifications\.?|limit exceeded)$/i;

const getErrorMessage = <T>(error: T): string => {
  if (error instanceof Error) return error.message;
  return truncateMessage(error) ?? "";
};

const isResizeObserverLoopError = <TMessage, TError>(
  message: TMessage,
  error?: TError,
): boolean => {
  const resolvedMessage = getErrorMessage(message) || getErrorMessage(error);
  return RESIZE_OBSERVER_LOOP_ERROR_PATTERN.test(resolvedMessage.trim());
};

const installGlobalTelemetry = (): void => {
  try {
    if (window.__bpmGlobalTelemetryInstalled) return;
    window.__bpmGlobalTelemetryInstalled = true;

    window.addEventListener("error", (event) => {
      try {
        if (!isResizeObserverLoopError(event.message, event.error)) {
          trackClientError(event.error ?? event.message);
        }
      } catch {
      }
    });

    window.addEventListener("unhandledrejection", (event) => {
      try {
        if (!isResizeObserverLoopError(event.reason)) {
          trackUnhandledRejection(event.reason);
        }
      } catch {
      }
    });
  } catch {
  }
};

installGlobalTelemetry();
